import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AccountantAnswer from "../../components/ask/answer/reader";
import { getAnswerAsk } from "../../store/actions/ask";
import {
  saveSurveyAsk,
  sendSurveyAsk,
  createAndSendAnswerAsk
} from "../../store/actions/ask/answers";
import Spinner from "../../components/general/spinner";
import {
  getTemplateDetailAsk,
  getTemplatesAsk
} from "../../store/actions/ask/templates";
import { changeViewedSurveyAsk } from "../../store/actions/ask/surveys";
import AskWizard from "../../components/ask/answer/wizard";
import ChooseTemplateAsk from "../../components/ask/edit/chooseTemplate";
import { FormattedMessage } from "react-intl";
import Page from "../../components/general/page";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";

const AskAnswerView = ({pageRef}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const main = useSelector(state => state.main);
  const ask = useSelector(state => state.ask);
  const company = useSelector(state => state.company);
  const myType = main.myType;  
  const answer = ask.answer.detail;  
  const isSavingAnswer = ask.answer.isSavingAnswer; 

  const intl = useIntl();

  const [setViewed, setSetViewed] = useState(false);
  const [answerId, setAnswerId] = useState(null);
  const [completed, setCompleted] = useState(null);
  const [chooseTemplate, setChooseTemplate] = useState(false);
  const [wizardCompleted, setWizardCompleted] = useState(false);
      
  useEffect(() => {
    
    const splitPathname = location.pathname.split("/");
    if (location.search.indexOf("?from=templates") > -1) {
      dispatch(getTemplatesAsk());
      setChooseTemplate(true);      
    } else if (location.search.indexOf("?from=") > -1) {
      let templateId = location.search.split("from=")[1];
      dispatch(getTemplateDetailAsk(templateId));
    } else if (splitPathname.length > 2) {
      let answerIdFromPath = splitPathname[2];
      setAnswerId(answerIdFromPath);
      dispatch(getAnswerAsk(answerIdFromPath)).then(res => {
        
        setCompleted(res.completedAt);
      });       
    }
  }, [location.pathname]);

  useEffect(() => {
    if (setViewed || !answerId || !answer || !answer.surveyId || answer.itemViewedAt || answer.managerViewedAt) return;
    dispatch(changeViewedSurveyAsk(answer.id,
      true).then(res => setSetViewed(true)));      
  }, []);
  
  const onTemplateSelection = (templateId) => {
    setChooseTemplate(false);    
    navigate("/ask-answer?from=" + templateId);
    dispatch(getTemplateDetailAsk(templateId));
  };

  const getItemDescription = (itemId) => {    
    let itemDescription = "";
    company?.companies?.map(item => {
      if (itemId === item.id) {
        itemDescription = `${item.ragioneSociale} / ${intl.formatMessage({ id: "generic.fiscalCodeAbbreviation" })} ${item.codiceFiscale}`;
      }
      return null;
    });
    return itemDescription;
  };

  const onConfirm = (
    method, answerId, items
  ) => {
    if (location.search.indexOf("?from=") > -1) {
      let templateId = location.search.split("?from=")[1];
      dispatch(createAndSendAnswerAsk(templateId,
        items))
        .then(res => {
          if (window.aptrinsic) {
            window.aptrinsic("track",
              "digital-box:ASK-NEW REPLY FROM TEMPLATE");
          }
          setWizardCompleted(true);         
        });
    } else if (method === "send") {
      dispatch(sendSurveyAsk(answerId,
        items))
        .then(res => {
          if (window.aptrinsic) {
            window.aptrinsic("track", "digital-box:ASK-NEW REPLY SEND");
          }
          setWizardCompleted(true);
        });
    } else {
      dispatch(saveSurveyAsk(answerId,
        items))
        .then(res => {
          if (window.aptrinsic) {
            window.aptrinsic("track", "digital-box:ASK-NEW REPLY SAVE");
          }
          navigate("/ask-list");
        });
    }
  };  
  return (
    <Page
      pageRef={pageRef}
      title={<FormattedMessage id="ask.pages.answer.title" />}        
      subtitle={
        answer.managerId ? (
          getItemDescription(answer.itemId)
        ) : myType !== "STUDIO" ? (
          <FormattedMessage id="ask.pages.list.subtitle" />
        ) : (
          ""
        )
      }
      backText={<FormattedMessage id="ask.pages.edit.back" />}
      backUrl="/ask-list"
    >
      {chooseTemplate ? (
        <ChooseTemplateAsk
          onSelection={templateId => onTemplateSelection(templateId)}
        />
      ) : isSavingAnswer ? (
        <Spinner
          size="large"
          tip={
            <span>
              <FormattedMessage id="generic.saving1" /> <br /> <FormattedMessage id="generic.loading2" />
            </span>
          }
        />
      ) : myType !== "STUDIO" && !completed ? (
        <AskWizard            
          wizardCompleted={wizardCompleted}
          fromTemplate={
            location.search.indexOf("?from=") > -1
          }
          onConfirm={onConfirm}
        />
      ) : (
        <AccountantAnswer />
      )}
    </Page>
  );
};

export default AskAnswerView;

